import React, { useEffect, useState } from "react";
import {
  Typography,
  Box,
  ListItemIcon,
  Divider,
  Avatar,
  TextField,
  InputAdornment,
} from "@mui/material";
import { useOutletContext, useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { profileSectionIcon } from "./profileSectionIcons";
import Credits from "../../components/MyProfile/credits";
import HelpSupport from "../../components/MyProfile/HelpSupport";
import MyProfileData from "../../components/MyProfile/MyProfileData";
import ChangePassword from "../../components/MyProfile/ChangePassword";

const MyProfile = ({ ActiveTab }) => {
  const navigate = useNavigate();
  const { open } = useOutletContext();
  const { profileData } = useSelector((state) => state.profile);
  const [activeTab, setActiveTab] = useState(ActiveTab);
  const location = useLocation();
  const lastSegment = location.pathname?.split("/")?.pop();

  const sidebarItems = [
    {
      label: "My Profile",
      icon:
        activeTab === "my-profile"
          ? profileSectionIcon.myprofileActiveIcon
          : profileSectionIcon.myProfileIcon,
      key: "my-profile",
      navigateto: "my-profile",
    },
    {
      label: "Change password",
      icon:
        activeTab == "change-password"
          ? profileSectionIcon.changePasswordActiveIcon
          : profileSectionIcon.changePasswordIcon,
      key: "change-password",
      navigateto: "change-password",
    },
    {
      label: "Credits",
      icon:
        activeTab == "credits"
          ? profileSectionIcon.creditActiveIcon
          : profileSectionIcon.creditIcon,
      key: "credits",
      navigateto: "credits",
    },
    {
      label: "Help & Support",
      icon:
        activeTab == "help-support"
          ? profileSectionIcon.helpandSupportActiveIcon
          : profileSectionIcon.helpandSupportIcon,
      key: "help-support",
      navigateto: "help-support",
    },
  ];

  useEffect(() => {
    setActiveTab(lastSegment)
  }, [lastSegment])
  return (
    <Box
      sx={{
        flexGrow: 1,
        p: 3,
        width: open ? "calc(100% - 240px)" : "calc(100% - 100px)",
        marginLeft: open ? "240px" : "100px",
        transition: "margin 0.3s ease",
        height: "100vh",
        display: "flex",
        background: "#f9f9f9",
      }}
    >
      <Box
        mt={10}
        style={{
          borderRadius: "12px",
          textAlign: "center",
          background: "#fff",
          width: "100%",
          height: "calc(100% - 73px)",
          marginLeft: open ? "" : "1em",
          display: "flex",
        }}
      >
        <Box sx={{ width: "24%", pt: "25px", textAlign: "left", overflow: "auto" }} >
          <Typography
            noWrap
            component="p"
            sx={{
              fontSize: "18px",
              fontWeight: 600,
              lineHeight: "20px",
              color: "#1D1D1D",
              ml: 2,
              pl: "20px",
            }}
          >
            Account Settings
          </Typography>
          <Box sx={{ display: "flex", alignItems: "center", gap: "20px" }}>
            <Box
              sx={{
                width: "100%",
                height: "100%",
                position: "relative",
                pt: 2,
              }}
            >
              {sidebarItems.map(({ label, icon, key, navigateto }) => (
                <Box
                  key={key}
                  sx={{
                    width: "100%",
                    height: "60px",
                    paddingLeft: "25px",
                    cursor: "pointer",
                    transition: "background 0.3s ease",
                    alignContent: "center",
                    background:
                      activeTab === key
                        ? "linear-gradient(90deg, rgba(24, 92, 183, 0.1) 19.22%, rgba(255, 255, 255, 0) 100%)"
                        : "#ffffff",
                    position: "relative",
                  }}
                  onClick={() => {
                    setActiveTab(key);
                    navigate(`/${navigateto}`);
                  }}
                >
                  {activeTab === key && (
                    <Box
                      sx={{
                        position: "absolute",
                        background: "#185CB7",
                        width: 6,
                        height: "100%",
                        top: 0,
                        left: 0,
                        borderRadius: "0 8px 8px 0",
                      }}
                    ></Box>
                  )}
                  <ListItemIcon
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: "16px",
                      color: activeTab === key ? "#185CB7" : "#1D1D1D",
                    }}
                  >
                    {icon}
                    <Typography sx={{ fontSize: "16px", fontWeight: 500 }}>
                      {label}
                    </Typography>
                  </ListItemIcon>
                </Box>
              ))}
            </Box>
          </Box>
        </Box>
        <Divider
          orientation="vertical"
          flexItem
          sx={{ borderWidth: "0 0 0 thin !important", margin: 0 }}
        />
        {activeTab == "my-profile" && <MyProfileData />}
        {activeTab == "change-password" && <ChangePassword />}
        {activeTab == "credits" && <Credits />}
        {activeTab == "help-support" && <HelpSupport />}
      </Box>
    </Box>
  );
};

export default MyProfile;
